import {DialogViewActionWidget,SPI,ActionWidget, ActionType, Condition} from '@kunlun/dependencies';
@SPI.ClassFactory(
    ActionWidget.Token({
        actionType: ActionType.View,
        name: "internalGotoListImportDialog",
        model: 'deli.aries.platform.fund.credit.DeliAriesPlatformDisCreditAccountHeadProxy'
    })
)
export class billDayImport extends DialogViewActionWidget { 
 protected async clickAction(): Promise<void> {
  this.action.context!.model = "'deli.aries.platform.fund.DeliPlatformDisCreditAccountProxy'";
      await super.clickAction();
      return;
 }
}
